// @ts-check

window.addEventListener("load", () => {
    const target = document.querySelectorAll(".zamg-js-target");
    if (target.length == 0) return;

    /*
        ? call the update img ajax and reload the image
    */

    fetch('?type=916104')
        .then((response) => {
            if (response.ok) return response.json();
            throw new Error("Network response was not ok.");
        })
        .then((res) => {
            target.forEach((target) => {
                if (target instanceof HTMLImageElement) {
                    target.src = res.fullPath;

                    const container = target.parentElement?.parentElement;
                    if (container) {
                        /** @type {HTMLElement|null} */
                        const spinner = container.querySelector(".loading-spinner");
                        spinner?.style.setProperty("opacity", "0");
                        setTimeout(() => spinner?.remove(), 1000);

                        /** @type {HTMLElement|null} */
                        const placeholder = container.querySelector(".zamg-js-target-placeholder");
                        placeholder?.style.setProperty("opacity", "0");
                        setTimeout(() => placeholder?.remove(), 1000);
                    }
                }
            });
        });
});